import Vue from 'vue'
import { Field, Checkbox, IndexBar, IndexAnchor, Overlay } from 'vant'

const components = [Field, Checkbox, IndexBar, IndexAnchor, Overlay]

components.forEach(component => Vue.use(component))
